import React, { Fragment } from 'react'
import AuthPage from './AuthPage'
import { Route, Routes, useLocation } from 'react-router-dom'
import InviteStart from 'modules/Assessments/Partials/AIInterview/InviteStart'
import AIInterview from 'modules/Assessments/Partials/AIInterview'
import InviteAssessmentRunner from 'modules/Assessments/Partials/Invite/InviteAssessmentRunner'
import { readInviteScopedJwt } from 'modules/Assessments/Partials/AIInterview/aiInterviewInviteAPI'

const AuthRouter = ({ isAuthenticated, getStudentData, SignIn }) => {
  const location = useLocation()
  const pathname = location?.pathname || ''

  // OTP-based invite flow runs without portal login. A candidate enters via
  // /assessment/start/:inviteToken (or the legacy /ai-interview/start/...),
  // verifies their email via OTP, then proceeds to the right runner using a
  // scoped JWT stashed in sessionStorage.
  const isAiInterviewInvite = pathname.startsWith('/ai-interview/start/')
  const isAssessmentInvite = pathname.startsWith('/assessment/start/')
  const isAiInterviewSession = /^\/ai-interview\/[^/]+$/.test(pathname) &&
    !pathname.startsWith('/ai-interview/start/')
  const isAssessmentTakeSession = /^\/assessment\/take\/[^/]+(?:\/[^/]+)?$/.test(pathname)

  // New generic key first, legacy AI-interview key as fallback.
  const hasScopedJwt = !!readInviteScopedJwt()

  // ---- Email/OTP screens (no auth).
  if (isAiInterviewInvite) {
    return (
      <Routes>
        <Route path="/ai-interview/start/:inviteToken" element={<InviteStart />} />
      </Routes>
    )
  }

  if (isAssessmentInvite) {
    return (
      <Routes>
        <Route path="/assessment/start/:inviteToken" element={<InviteStart />} />
      </Routes>
    )
  }

  // If a candidate hit /ai-interview/:assignedId via the OTP flow, serve the
  // standalone interview screen without routing through AuthPage / portal
  // login. A scoped invite JWT in sessionStorage is the reliable signal that
  // this browser is in an OTP invite flow, so it takes precedence even when a
  // portal session also happens to be present (e.g. an admin testing the link).
  if (isAiInterviewSession && hasScopedJwt) {
    return (
      <Routes>
        <Route path="/ai-interview/:assignedId" element={<AIInterview />} />
      </Routes>
    )
  }

  // Non-AI assessment types (Aptitude / Communication / Hinglish / Custom /
  // Behavior) launched from an OTP invite land on /assessment/take/:id/:setId.
  if (isAssessmentTakeSession && hasScopedJwt) {
    return (
      <Routes>
        <Route
          path="/assessment/take/:assignedId"
          element={<InviteAssessmentRunner />}
        />
        <Route
          path="/assessment/take/:assignedId/:setId"
          element={<InviteAssessmentRunner />}
        />
      </Routes>
    )
  }

  return (
    <Fragment>
      <AuthPage
        isAuthenticated={isAuthenticated}
        getStudentData={getStudentData}
        SignIn={SignIn}
      />
    </Fragment>
  )
}

export default AuthRouter